import React from "react";
import styled from "styled-components";
import { BsTelephoneFill } from "react-icons/bs";
import { LuMail } from "react-icons/lu";
import { device } from "../styles/global";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";

const StyledContactHeader = styled.header`
  background-image: var(--light-to-dark);
  color: var(--white);
  padding: 1rem 0;

  a:hover {
    color: var(--white);
    text-decoration: underline;
    text-underline-offset: 25%;
  }

  .width-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .left,
  .contact,
  .right {
    display: flex;
    align-items: center;
  }

  a.contact {
    gap: 0.6rem;
    white-space: nowrap;
  }

  .right {
    gap: 0.875rem;
  }

  .left,
  .width-wrapper {
    gap: 1.5rem;
  }

  svg {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  a.facebook,
  a.linkedin {
    transition: all 0.2s ease-in-out;

    &:hover {
      transform: scale(1.2);
    }
  }

  a.facebook svg {
    height: 0.875rem;
    height: 0.875rem;
  }

  a.linkedin svg {
    height: 1rem;
    width: 1rem;
  }

  @media ${device.laptopS} {
    .width-wrapper {
      justify-content: center;
    }

    .right {
      gap: 1.5rem;
    }
  }

  @media ${device.mobileL} {
    .left,
    .width-wrapper {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
    }

    .right {
      gap: 0.875rem;
    }
  }
`;

const ContactHeader = () => {
  return (
    <StyledContactHeader>
      <div className="width-wrapper">
        <div className="left">
          <a href="mailto:info@qtatax.com" className="contact">
            <LuMail />
            info@qtatax.com
          </a>
          <a href="tel:%20630-881-4679" className="contact">
            <BsTelephoneFill />
            630-881-4679
          </a>
        </div>
        <div className="right">
          <a
            href="https://www.facebook.com/QTATaxLtd/"
            target="_blank"
            rel="noopener noreferrer"
            className="facebook"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://www.linkedin.com/in/renata-bliumaite-e-a-b67aa523a/"
            target="_blank"
            rel="noopener noreferrer"
            className="linkedin"
          >
            <FaLinkedinIn />
          </a>
        </div>
      </div>
    </StyledContactHeader>
  );
};

export default ContactHeader;
